import gql from "../gql";
export default gql `
  fragment NextMilestone on MilestoneSummary {
    __typename
    celebration
    description
    id
    label
    minuteTotal
    optional
    pointTotal
    position
    progress {
      ...Progress
    }
    stepCount
    type
  }
`;
